var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"settings",attrs:{"shadow":"never"}},[_c('div',{staticClass:"settings-header",attrs:{"slot":"header"},slot:"header"},[_vm._v("查询组件\n    "),_c('el-button',{staticStyle:{"margin-left":"8px"},attrs:{"type":"danger"},on:{"click":_vm.deleteitem}},[_vm._v("删除")])],1),_c('div',[_vm._v("目前只做占位，无配置项")])])
}
var staticRenderFns = []

export { render, staticRenderFns }